import type { ActionEvidence, ActionType } from '@0xtorch/core'
import type { ActionError } from './actionFilter'

type TextFilterOperator =
  | 'eq'
  | 'like'
  | 'not-like'
  | 'is-empty'
  | 'is-not-empty'

type MathFilterOperator = 'eq' | 'gte' | 'lte'

export type HistoryPageFilters = {
  account?: {
    operator: 'in-array' | 'not-in-array'
    value: number[]
  }
  amount?: {
    operator: MathFilterOperator
    value: string
  }
  app?: {
    operator: 'in-array' | 'not-in-array'
    value: string[]
  }
  asset?: {
    operator: 'in-array' | 'not-in-array'
    value: string[]
  }
  category?: {
    operator: 'in-array' | 'not-in-array'
    value: string[]
  }
  file?: {
    operator: 'in-array' | 'not-in-array'
    value: number[]
  }
  comment?: {
    operator: TextFilterOperator
    value: string
  }
  crossId?: {
    operator: TextFilterOperator
    value: string
  }
  error?: {
    operator: 'in-array' | 'not-in-array'
    value: ActionError[]
  }
  evidence?: {
    operator: 'in-array' | 'not-in-array'
    value: ActionEvidence[]
  }
  evmFunction?: {
    operator: TextFilterOperator
    value: string
  }
  evmTo?: {
    operator: TextFilterOperator
    value: string
  }
  loanId?: {
    operator: TextFilterOperator
    value: string
  }
  timestamp?: {
    from: string | undefined
    to: string | undefined
  }
  transferIn?: {
    operator: MathFilterOperator
    value: string
  }
  transferOut?: {
    operator: MathFilterOperator
    value: string
  }
  transfer?: {
    operator:
      | 'in-array'
      | 'not-in-array'
      | 'in-array-from'
      | 'not-in-array-from'
      | 'in-array-to'
      | 'not-in-array-to'
    value: string[]
  }
  type?: {
    operator: 'in-array' | 'not-in-array'
    value: ActionType[]
    subTypeValue: number[]
  }
}

export type HistoryPageFilterType = keyof HistoryPageFilters

const historyPageSortTypes = ['timestamp', 'pl'] as const

export type HistoryPageSortType = (typeof historyPageSortTypes)[number]

export const isHistoryPageSortType = (
  value: string,
): value is HistoryPageSortType =>
  historyPageSortTypes.some((sortType) => sortType === value)

export type HistoryPageSort = {
  readonly type: HistoryPageSortType
  readonly order: 'asc' | 'desc'
}
